export const COOKIES_KEY_LOCALSTORAGE = "sf-cookies-accepted";
export const COOKIES_STATES = {
  UNKNOWN: "UNKNOWN",
  ACCEPTED: "ACCEPTED",
  REFUSED: "REFUSED",
};
